/** 仅收录有可核验文件记录的版本；无文件时不提供 Download */
export const CURRENT_APK_URL =
	'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.39.930_gw_10_26.apk'

/** 与 Content-Length 一致：200614176 bytes ≈ 191.3 MB */
export const CURRENT_APK_SIZE_LABEL = '~191.3 MB'

/**
 * 版本表数据来源：同 CDN 路径下可 HEAD 通的 APK。
 * 营销版本号仅在站点已使用时填写；其余用构建号，避免编造。
 * Android 要求沿用全站安装说明中的常见下限，并提示用户自行确认。
 */
export const APK_VERSION_HISTORY = [
	{
		version: 'v18.80',
		buildLabel: '2.26.39.930',
		releasePeriod: 'Current release',
		fileSize: '~191.3 MB',
		fileSizeBytes: 200614176,
		androidRequirement: 'Android 5.0+ (confirm on device)',
		status: 'Current',
		apkUrl: CURRENT_APK_URL,
		details:
			'Latest APK on this site. Prefer this build unless you have a specific reason to use an older package.',
	},
	{
		version: 'v18.70',
		buildLabel: '2.26.27.910',
		releasePeriod: 'Previous release line',
		fileSize: '~146.2 MB',
		fileSizeBytes: 153332961,
		androidRequirement: 'Android 5.0+ (confirm on device)',
		status: 'Previous',
		apkUrl: 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk',
		details:
			'Earlier package from the 2.26.27 line. Useful for comparison when a newer build has install or runtime issues on your device.',
	},
	{
		version: 'Build 2.26.27.930',
		buildLabel: '2.26.27.930',
		releasePeriod: 'Previous release line',
		fileSize: '~146.3 MB',
		fileSizeBytes: 153365729,
		androidRequirement: 'Android 5.0+ (confirm on device)',
		status: 'Previous',
		apkUrl: 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.930_gw.apk',
		details:
			'File on the same CDN path. No separate marketing version label is claimed beyond the build number in the filename.',
	},
	{
		version: 'Build 2.26.19.906',
		buildLabel: '2.26.19.906',
		releasePeriod: 'Earlier archived build',
		fileSize: '~136.4 MB',
		fileSizeBytes: 143014510,
		androidRequirement: 'Android 5.0+ (confirm on device)',
		status: 'Archived',
		apkUrl: 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.906_gw.apk',
		details:
			'Older APK kept for archive comparison. An older build is not automatically safer or more compatible.',
	},
	{
		version: 'Build 2.26.19.876',
		buildLabel: '2.26.19.876',
		releasePeriod: 'Earlier archived build',
		fileSize: '~136.4 MB',
		fileSizeBytes: 142998126,
		androidRequirement: 'Android 5.0+ (confirm on device)',
		status: 'Archived',
		apkUrl: 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.876_gw_07_14.apk',
		details:
			'Archived file. Availability of a file does not guarantee that the build still works with current WhatsApp services.',
	},
]
